import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import moment from "moment";
import { IAdminAccountItem } from "interfaces";
import { isHaveActionPermission } from "utills/helpers";

interface AdminAccountCardProps {
  data?: IAdminAccountItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const AdminAccountCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: AdminAccountCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IAdminAccountItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <SwitchButton
              checked={item.is_active}
              disabled={!isHaveActionPermission("account", "admin", "edit")}
              onChange={() => _toggleActive(item.id, !item.is_active)}
            />

            <div className="flex items-center gap-x-[8px]">
              <Link to={`/admin-accounts/accounts/${item.id}`} className="w-fit">
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission("account", "admin", "edit") ? (
                <Link
                  to={`/admin-accounts/accounts/${item.id}/edit`}
                  className="w-fit"
                >
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Full Name</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.first_name} {item.last_name}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Email</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.email}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Role</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.role_name}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Created at/by</p>
            <div className="flex-1 text-right text-sm leading-6 capitalize">
              <p>
                {item.created ? moment(item.created).format("DD/MM/YYYY HH:mm:ss") : ""}
              </p>
              <p>{item.created_by}</p>
            </div>
          </li>
        </div>
      ))}
    </ul>
  );
};
